import { render, staticRenderFns } from "./ClipboardDialog.vue?vue&type=template&id=73fa177e&"
import script from "./ClipboardDialog.vue?vue&type=script&lang=ts&"
export * from "./ClipboardDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ClipboardDialog.vue?vue&type=style&index=0&id=73fa177e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports